<template>
  <div>
    <form name="newDocument" @submit.prevent="handleSubmit()">
      <div class="modal-body">
        <label>File Attach</label>
        <input
          v-validate="'ext:doc,docx,pdf,PDF'"
          type="file"
          name="file"
          ref="file"
          class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('file') }"
          v-on:change="handleFileUpload()"
        />
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Upload</button>
      </div>
    </form>
  </div>
</template>

<script>
import {

  authHeaderPost,
  notifyHelper,
  EncodeURL,
  responseCheck
  
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      file: '',
      submitted: false
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },
    url:{
      type: String,
      required : true
    }
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    handleSubmit() {
      this.submitted = true
      this.$validator.validate().then(valid => {
        if (valid) {
          this.processSave()
        } else {
          this.submitted = false
        }
      })
    },
    processSave() {
      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('ID', this.id)
      let loader = this.$loading.show()
      instance
        .post(EncodeURL + this.url, formData, {
          headers: authHeaderPost()
        })
        .then(response => {
          if (!response.data.error) {
            notifyHelper('success', response.data.message)
            this.$emit('done-edit-att')
          } else {
            notifyHelper('error', response.data.message)
          }
          this.submitted = false
          loader.hide()
        })
        .catch(function (error) {
          responseCheck(error.response.status)
        })
    }
  }
}
</script>
